import { render, staticRenderFns } from "./educationlist.vue?vue&type=template&id=5a131966&scoped=true&"
import script from "./educationlist.vue?vue&type=script&lang=js&"
export * from "./educationlist.vue?vue&type=script&lang=js&"
import style0 from "./educationlist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./educationlist.vue?vue&type=style&index=1&id=5a131966&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a131966",
  null
  
)

export default component.exports